<template>
  <div>
    <b-modal id="modalAcceptance"
             :title="modalTitle"
             centered
             hide-footer
             v-bind="$attrs">
      <div class="footer_btn">
        <b-btn @click="hideModal"
               v-text="'Cancel'"/>
        <b-btn :variant="okButtonVariant"
               @click="handleOk"
               v-text="okButtonText"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
  export default {
    name: 'ModalAcceptance',
    props: {
      modalTitle: {
        type: String,
        default: '',
      },
      okButtonText: {
        type: String,
        default: '',
      },
      okButtonVariant: {
        type: String,
        default: 'danger',
      },
    },
    methods: {
      handleOk() {
        this.hideModal();
        this.$emit('ok');
      },
      hideModal() {
        this.$nextTick(() => {
          this.$bvModal.hide('modalAcceptance');
        });
      },
    },
  };
</script>

<style lang="scss"
       scoped>
  .footer_btn {
    display: flex;
    justify-content: space-between;
  }
</style>
